var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu",class:{ 'small-menu': _vm.smallMenu },staticStyle:{"background-color":"#2D2E2C"}},_vm._l((_vm.menuTree),function(item,index){return _c('MenuItem',{key:index,attrs:{"data":item.children,"label":item.label,"icon":item.icon,"url":item.url,"depth":0,"smallMenu":_vm.smallMenu}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }